var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "tr",
    {
      directives: [
        {
          name: "tooltip",
          rawName: "v-tooltip.top-start",
          value: {
            content: `Document id: ${_vm.row.doc.docPid}`,
            trigger: "hover",
            hideOnTargetClick: false,
            autoHide: false,
          },
          expression:
            "{\n\t\tcontent: `Document id: ${row.doc.docPid}`,\n\t\ttrigger: 'hover',\n\t\thideOnTargetClick: false,\n\t\tautoHide: false,\n\t}",
          modifiers: { "top-start": true },
        },
      ],
      staticClass: "document",
    },
    _vm._l(_vm.cols.docColumns, function (col) {
      return _c(
        "td",
        {
          key: col.key,
          class: col.class,
          style: col.style,
          attrs: { colspan: col.colspan },
        },
        [
          col.field === "summary"
            ? _c(
                "a",
                {
                  staticClass: "doctitle",
                  attrs: { target: "_blank", href: _vm.row.href },
                },
                [_vm._v(_vm._s(_vm.row.summary))]
              )
            : col.field === "metadata"
            ? [
                _vm._v(
                  _vm._s(
                    (col.metadata &&
                      _vm.row.doc.docInfo[col.metadata.id]?.join(", ")) ||
                      ""
                  )
                ),
              ]
            : col.field === "hits"
            ? [_vm._v(_vm._s(_vm.row.doc.numberOfHits))]
            : _vm._e(),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }